import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtDateTime } from "../lib/api";
import { Page } from "../components/AppShell";
import { CheckCircle, Lock, ClockClockwise } from "@phosphor-icons/react";

export default function MyJobs() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/customer/jobs")
      .then((r) => setJobs(r.data || []))
      .catch(() => { /* core admin will 403 — silent for empty-state */ })
      .finally(() => setLoading(false));
  }, []);

  return (
    <Page
      title="My Jobs"
      subtitle="JOBS YOU'VE SUBMITTED. EDITABLE UNTIL THE HOST ACKNOWLEDGES."
      breadcrumbs={[{ label: "Dashboard", to: "/" }, "My Jobs"]}
      actions={<Link to="/submit-job" className="btn btn-primary" data-testid="myjobs-new">+ NEW JOB</Link>}
      testid="my-jobs-page"
    >
      <div className="max-w-6xl mx-auto">

      {loading ? <div className="p-8 text-center text-muted-foreground" data-testid="myjobs-loading">Loading…</div>
       : jobs.length === 0 ? (
          <div className="surface p-12 text-center text-muted-foreground" data-testid="myjobs-empty">
            <ClockClockwise size={28} weight="thin" className="mx-auto mb-2" />
            You haven&apos;t submitted any jobs yet.
            <div className="mt-3"><Link to="/submit-job" className="btn btn-primary">SUBMIT YOUR FIRST JOB</Link></div>
          </div>
        ) : (
        <div className="surface">
          <table className="dense">
            <thead><tr><th>JOB #</th><th>HOST ORG</th><th>STATUS</th><th>LOCK</th><th>SUBMITTED</th><th>NOTES</th></tr></thead>
            <tbody>
              {jobs.map((j) => (
                <tr key={j.id} data-testid={`myjob-row-${j.id}`}>
                  <td className="mono text-xs">{j.job_number}</td>
                  <td className="text-xs">{j.host_org_name}</td>
                  <td className="text-xs">{j.status_name || "—"}</td>
                  <td className="text-xs">
                    {j.acknowledged
                      ? <span className="badge badge-default" style={{ background: "#FEE2E2", color: "#B91C1C" }} data-testid={`myjob-locked-${j.id}`}><Lock size={10} /> ACKNOWLEDGED</span>
                      : <span className="badge badge-default" style={{ background: "#D1FAE5", color: "#065F46" }} data-testid={`myjob-editable-${j.id}`}><CheckCircle size={10} /> EDITABLE</span>}
                  </td>
                  <td className="text-xs text-muted-foreground mono">{fmtDateTime(j.created_at)}</td>
                  <td className="text-xs text-muted-foreground truncate" style={{ maxWidth: 280 }}>{j.notes || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      </div>
    </Page>
  );
}
